/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { useActionToast, useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { getFetchData, isRequestFailure, useFetch } from '../../../hooks/useFetch';
import { SwitchInputForm } from '../../inputs/forms/SwitchInputForm';
import { FormActions, FormRow, FormSection, FormShell } from '../../ui';
import { FileInputForm } from '../../inputs/forms/FileInputForm';
import { TextAreaInputForm } from '../../inputs/forms/TextAreaInputForm';
import { SelectInputForm } from '../../inputs/forms/SelectInputForm';
import { getFormattedLabel } from '../../../utils/FormatFunctions';
import { getApiErrorMessage } from '../../../utils/apiError';

interface ExtraMaterialFormProps {
  defaultValues?: any;
  view?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup?: any;
}

export default function ExtraMaterialForm({
  defaultValues = {},
  view = false,
}: ExtraMaterialFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/extra_materials';
  const { requestApi, error } = useFetch(baseUrl);
  const {
    requestApi: reqApiInstitutions,
    data: dataInstitutions,
    loading: loadingInstitutions,
  } = useFetch('/v1/admin/institutions');
  const { data: optionsInstitutions, pagination: paginationInstitutions } =
    getFetchData(dataInstitutions);
  const {
    requestApi: reqApiModules,
    data: dataModules,
    loading: loadingModules,
  } = useFetch('/v1/admin/classes');
  const { data: optionsModules, pagination: paginationModules } = getFetchData(dataModules);
  const {
    requestApi: reqApiCategories,
    data: dataCategories,
    loading: loadingCategories,
  } = useFetch('/v1/admin/categories');
  const { data: optionsCategories, pagination: paginationCategories } =
    getFetchData(dataCategories);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { itemId } = useParams();
  const navigate = useNavigate();
  const toast = useActionToast();
  const [applyAllInstitutions, setApplyAllInstitutions] = useState(false);
  const [isSelectingAllInstitutions, setIsSelectingAllInstitutions] = useState(false);
  const [institutionOptionsCache, setInstitutionOptionsCache] = useState<any[]>(
    Array.isArray(defaultValues?.institutions)
      ? defaultValues.institutions.map((inst: any) => getFormattedLabel(inst))
      : []
  );
  const [applyAllModules, setApplyAllModules] = useState(false);
  const [isSelectingAllModules, setIsSelectingAllModules] = useState(false);
  const [moduleOptionsCache, setModuleOptionsCache] = useState<any[]>(
    Array.isArray(defaultValues?.school_classes)
      ? defaultValues.school_classes.map((mod: any) => getFormattedLabel(mod))
      : []
  );

  const optionsUserType = [
    {
      label: 'Professor',
      value: 'PROFESSOR',
    },
    {
      label: 'Responsável',
      value: 'RESPONSAVEL',
    },
    {
      label: 'Todos',
      value: 'TODOS',
    },
  ];
  const optionsType = [
    {
      label: 'Mídia',
      value: 'MIDIA',
    },
    {
      label: 'Link',
      value: 'LINK',
    },
  ];

  const formattedInstitutionOptions = useMemo(() => {
    const fetchedOptions = optionsInstitutions?.map((item) => getFormattedLabel(item)) ?? [];

    if (!institutionOptionsCache.length) {
      return fetchedOptions;
    }

    const mergedOptions = [...institutionOptionsCache, ...fetchedOptions];
    const uniqueOptionsMap = new Map<number | string, { value: any; label: string }>();

    mergedOptions.forEach((option) => {
      if (!uniqueOptionsMap.has(option.value)) {
        uniqueOptionsMap.set(option.value, option);
      }
    });

    return Array.from(uniqueOptionsMap.values());
  }, [optionsInstitutions, institutionOptionsCache]);

  const formattedModuleOptions = useMemo(() => {
    const fetchedOptions = optionsModules?.map((item) => getFormattedLabel(item)) ?? [];

    if (!moduleOptionsCache.length) {
      return fetchedOptions;
    }

    const mergedOptions = [...moduleOptionsCache, ...fetchedOptions];
    const uniqueOptionsMap = new Map<number | string, { value: any; label: string }>();

    mergedOptions.forEach((option) => {
      if (!uniqueOptionsMap.has(option.value)) {
        uniqueOptionsMap.set(option.value, option);
      }
    });

    return Array.from(uniqueOptionsMap.values());
  }, [optionsModules, moduleOptionsCache]);

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues.name ?? '',
      placeholder: 'Título do material',
      label: 'Título',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'description',
      value: defaultValues.description ?? '',
      placeholder: 'Insira a descrição',
      label: 'Descrição',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'school_class_ids',
      value: defaultValues?.school_classes
        ? defaultValues.school_classes.map((mod: any) => getFormattedLabel(mod))
        : [],
      placeholder: 'Selecione um ou mais módulos',
      label: 'Módulo',
    },
    {
      name: 'institution_ids',
      value: defaultValues?.institutions
        ? defaultValues.institutions.map((inst: any) => getFormattedLabel(inst))
        : [],
      placeholder: 'Selecione uma ou mais instituições',
      label: 'Instituições',
    },
    {
      name: 'user_type',
      value: defaultValues?.user_type
        ? optionsUserType.find((item) => item.value === defaultValues?.user_type)
        : optionsUserType.find((item) => item.value === 'TODOS'),
      placeholder: 'Selecione o tipo de usuário que receberá',
      label: 'Usuários que vão receber',
      yup: Yup.mixed(),
    },
    {
      name: 'category_id',
      value: defaultValues?.category ? getFormattedLabel(defaultValues?.category) : null,
      placeholder: 'Selecione uma categoria',
      label: 'Categoria',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'type',
      value: defaultValues?.type
        ? optionsType.find((item) => item.value === defaultValues?.type)
        : '',
      placeholder: 'Selecione o tipo do arquivo',
      label: 'Tipo',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'link',
      value: defaultValues.link ?? '',
      placeholder: 'exemplo link: https://www.youtube.com/',
      label: 'Link do material',
      yup: Yup.string().test('is-file', 'Este campo é obrigatório!', function (value: any) {
        if (this.parent.type === 'LINK' || this.parent.type?.value === 'LINK') return value;
        return true;
      }),
    },
    {
      name: 'file',
      value: defaultValues.file?.original ?? null,
      placeholder: '',
      label: 'Anexo',
      yup: Yup.mixed()
        .nullable()
        .test('is-file', 'Este campo é obrigatório!', function (value) {
          if (this.parent.type === 'MIDIA' || this.parent.type?.value === 'MIDIA') return value;
          return true;
        })
        .test('is-file', 'O arquivo tem o limite máximo de 100MB', function (value) {
          // megabytes
          const maxSizeInBytes = 100 * 1024 * 1024;
          // console.log('onSubmit | maxSizeInBytes: ', maxSizeInBytes);
          // console.log('onSubmit | file.size: ', this.parent.file?.[0]?.size);
          if (this.parent.file?.[0]?.size > maxSizeInBytes) return false;
          return true;
        }),
    },
    {
      name: 'status',
      value: defaultValues.status ?? true,
      label: 'Status',
      yup: Yup.boolean(),
    },
    {
      name: 'is_downloadable',
      value: defaultValues.is_downloadable ?? true,
      label: 'Download',
      yup: Yup.boolean(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });
  const name = formInputs.find((field) => field.name === 'name');
  const description = formInputs.find((field) => field.name === 'description');
  const modules = formInputs.find((field) => field.name === 'school_class_ids');
  const institutions = formInputs.find((field) => field.name === 'institution_ids');
  const userType = formInputs.find((field) => field.name === 'user_type');
  const category = formInputs.find((field) => field.name === 'category_id');
  const type = formInputs.find((field) => field.name === 'type');
  const link = formInputs.find((field) => field.name === 'link');
  const file = formInputs.find((field) => field.name === 'file');
  const status = formInputs.find((field) => field.name === 'status');
  const download = formInputs.find((field) => field.name === 'is_downloadable');
  const selectedInstitutionsValue = watch('institution_ids');
  const selectedInstitutionsCount = Array.isArray(selectedInstitutionsValue)
    ? selectedInstitutionsValue.length
    : 0;
  const selectedModulesValue = watch('school_class_ids');
  const selectedModulesCount = Array.isArray(selectedModulesValue)
    ? selectedModulesValue.length
    : 0;

  // Validação para "FORMAÇÃO DE PROFESSORES"
  useEffect(() => {
    if (Array.isArray(selectedModulesValue) && selectedModulesValue.length > 1) {
      const hasFormacaoProfessores = selectedModulesValue.some(
        (mod) =>
          mod?.label?.toUpperCase().includes('FORMAÇÃO DE PROFESSORES') ||
          mod?.label?.toUpperCase().includes('FORMACAO DE PROFESSORES')
      );

      if (hasFormacaoProfessores) {
        toast({
          title: 'Seleção inválida',
          description:
            'FORMAÇÃO DE PROFESSORES não pode ser vinculado com outros módulos. Por favor, selecione apenas este módulo ou remova-o da seleção.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });

        // Remove os outros módulos, mantendo apenas FORMAÇÃO DE PROFESSORES
        const formacaoProfessores = selectedModulesValue.find(
          (mod) =>
            mod?.label?.toUpperCase().includes('FORMAÇÃO DE PROFESSORES') ||
            mod?.label?.toUpperCase().includes('FORMACAO DE PROFESSORES')
        );
        setValue('school_class_ids', [formacaoProfessores], {
          shouldDirty: true,
          shouldTouch: true,
        });
      }
    }
  }, [selectedModulesValue]);

  const handleToggleAllInstitutions = async () => {
    if (applyAllInstitutions) {
      setValue('institution_ids', [], { shouldDirty: true, shouldTouch: true });
      setApplyAllInstitutions(false);
      return;
    }

    try {
      setIsSelectingAllInstitutions(true);
      const response = await reqApiInstitutions('get', { params: { per_page: 2000 } });
      const fetchedInstitutions = response?.data?.data ?? [];
      const formatted = fetchedInstitutions.map((inst: any) => getFormattedLabel(inst));

      if (!formatted.length) {
        toast({
          title: 'Nenhuma instituição encontrada',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        setValue('institution_ids', [], { shouldDirty: true, shouldTouch: true });
        setApplyAllInstitutions(false);
        return;
      }

      setInstitutionOptionsCache(formatted);
      setValue('institution_ids', formatted, { shouldDirty: true, shouldTouch: true });
      setApplyAllInstitutions(true);
    } catch (errorToggle) {
      toast({
        title: 'Erro ao selecionar todas as instituições',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSelectingAllInstitutions(false);
    }
  };

  const handleToggleAllModules = async () => {
    if (applyAllModules) {
      setValue('school_class_ids', [], { shouldDirty: true, shouldTouch: true });
      setApplyAllModules(false);
      return;
    }

    try {
      setIsSelectingAllModules(true);
      const response = await reqApiModules('get', { params: { per_page: 2000 } });
      const fetchedModules = response?.data?.data ?? [];
      const formatted = fetchedModules.map((mod: any) => getFormattedLabel(mod));

      if (!formatted.length) {
        toast({
          title: 'Nenhum módulo encontrado',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        setValue('school_class_ids', [], { shouldDirty: true, shouldTouch: true });
        setApplyAllModules(false);
        return;
      }

      setModuleOptionsCache(formatted);
      setValue('school_class_ids', formatted, { shouldDirty: true, shouldTouch: true });
      setApplyAllModules(true);
    } catch (errorToggle) {
      toast({
        title: 'Erro ao selecionar todos os módulos',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSelectingAllModules(false);
    }
  };

  useEffect(() => {
    if (Array.isArray(defaultValues?.institutions) && defaultValues.institutions.length > 0) {
      setInstitutionOptionsCache((prevOptions) => {
        const formattedDefaults = defaultValues.institutions.map((inst: any) =>
          getFormattedLabel(inst)
        );
        const combined = [...prevOptions, ...formattedDefaults];
        const uniqueOptions = new Map<number | string, { value: any; label: string }>();

        combined.forEach((option) => {
          if (!uniqueOptions.has(option.value)) {
            uniqueOptions.set(option.value, option);
          }
        });

        return Array.from(uniqueOptions.values());
      });
    }
  }, [defaultValues?.institutions]);

  useEffect(() => {
    if (Array.isArray(defaultValues?.school_classes) && defaultValues.school_classes.length > 0) {
      setModuleOptionsCache((prevOptions) => {
        const formattedDefaults = defaultValues.school_classes.map((mod: any) =>
          getFormattedLabel(mod)
        );
        const combined = [...prevOptions, ...formattedDefaults];
        const uniqueOptions = new Map<number | string, { value: any; label: string }>();

        combined.forEach((option) => {
          if (!uniqueOptions.has(option.value)) {
            uniqueOptions.set(option.value, option);
          }
        });

        return Array.from(uniqueOptions.values());
      });
    }
  }, [defaultValues?.school_classes]);

  useEffect(() => {
    if (!applyAllInstitutions) {
      return;
    }

    if (!Array.isArray(selectedInstitutionsValue)) {
      setApplyAllInstitutions(false);
      return;
    }

    const totalOptions = institutionOptionsCache.length
      ? institutionOptionsCache.length
      : formattedInstitutionOptions.length;

    if (!totalOptions || selectedInstitutionsValue.length !== totalOptions) {
      setApplyAllInstitutions(false);
    }
  }, [
    applyAllInstitutions,
    selectedInstitutionsValue,
    institutionOptionsCache.length,
    formattedInstitutionOptions.length,
  ]);

  useEffect(() => {
    if (!applyAllModules) {
      return;
    }

    if (!Array.isArray(selectedModulesValue)) {
      setApplyAllModules(false);
      return;
    }

    const totalModuleOptions = moduleOptionsCache.length
      ? moduleOptionsCache.length
      : optionsModules?.length ?? 0;

    if (!totalModuleOptions || selectedModulesValue.length !== totalModuleOptions) {
      setApplyAllModules(false);
    }
  }, [applyAllModules, selectedModulesValue, moduleOptionsCache.length, optionsModules?.length]);

  const onSubmit = async (values: any) => {
    const tratedShortedLink = `https://${values?.link}`;
    const handleLink = values.link.includes('http') ? values?.link : tratedShortedLink;
    const params = {
      ...values,
      type: values.type.value,
      link: values.type?.value === 'LINK' || values.type === 'LINK' ? handleLink : _,
      school_class_ids: Array.isArray(values.school_class_ids)
        ? values.school_class_ids.map((mod: any) => mod.value)
        : [],
      institution_ids: Array.isArray(values.institution_ids)
        ? values.institution_ids.map((inst: any) => inst.value)
        : [values.institution_ids.value],
      category_id: values.category_id.value,
      user_type: values.user_type.value,
      file: _,
    };
    const { status: resStatus, data } = await requestApi(
      defaultValues.name ? 'put' : 'post',
      params,
      defaultValues.name ? `${baseUrl}/${itemId}` : null
    );
    if (
      (resStatus === 200 || resStatus === 201) &&
      typeof values.file === 'object' &&
      values.file?.length > 0 &&
      ((values.type.value !== undefined && values.type.value === 'MIDIA') ||
        values.type === 'MIDIA')
    ) {
      const formData = new FormData();
      formData.append('file', values.file[0]);
      const apiUrlId = itemId ?? data?.data?.id;
      const result = await requestApi('put', formData, `${baseUrl}/${apiUrlId}/files`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    if (resStatus === 200 || resStatus === 201) navigate('/extraMaterials');
  };

  useEffect(() => {
    if (defaultValues.name) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);

  const isEdit = Boolean(view ? 'visualizar' : defaultValues.name);

  return (
    <FormShell
      title={isEdit ? 'Editar Material' : 'Criar Material'}
      backTo="/extraMaterials"
      backLabel="Materiais Extras"
    >
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Dados Básicos">
          <FormRow>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              isDisabled={view}
              register={register}
              errors={errors}
            />
            <SwitchInputForm
              name={status?.name}
              label={status?.label}
              isDisabled={view}
              errors={errors}
              control={control}
            />
            {!defaultValues?.link && (
              <SwitchInputForm
                subLabel="Download ?"
                name={download?.name}
                label={download?.label}
                isDisabled={view}
                errors={errors}
                control={control}
              />
            )}
          </FormRow>

          <Box flex={1}>
            <TextAreaInputForm
              name={description?.name}
              label={description?.label}
              placeholder={description?.placeholder}
              isRequired
              isDisabled={view}
              errors={errors}
              register={register}
            />
          </Box>

          <Flex gap={5} align="stretch" flexWrap={{ base: 'wrap', md: 'nowrap' }}>
            <Box flex={1} minW={{ base: '100%', md: '0' }}>
              <Flex direction="column" gap={2}>
                <SelectInputForm
                  name={institutions?.name}
                  label={institutions?.label}
                  options={formattedInstitutionOptions}
                  isLoading={loadingInstitutions}
                  pagination={paginationInstitutions}
                  isDisabled={view}
                  getOptions={(filters) => reqApiInstitutions('get', { params: { ...filters } })}
                  placeholder={institutions?.placeholder}
                  control={control}
                  errors={errors}
                  isMulti
                />
                {!view && (
                  <Flex direction="column" gap={1}>
                    <Button
                      size="sm"
                      w={{ base: '100%', sm: 'auto' }}
                      alignSelf={{ base: 'stretch', sm: 'flex-start' }}
                      variant={applyAllInstitutions ? 'solid' : 'outline'}
                      onClick={handleToggleAllInstitutions}
                      isLoading={isSelectingAllInstitutions}
                      isDisabled={loadingInstitutions || isSelectingAllInstitutions}
                    >
                      {applyAllInstitutions
                        ? 'Remover seleção de todas'
                        : 'Aplicar em todas as instituições'}
                    </Button>
                    {selectedInstitutionsCount > 0 && (
                      <Text fontSize="xs" color="content.subtle">
                        {selectedInstitutionsCount}{' '}
                        {selectedInstitutionsCount > 1
                          ? 'instituições selecionadas'
                          : 'instituição selecionada'}
                        {applyAllInstitutions ? ' (todas)' : ''}
                      </Text>
                    )}
                  </Flex>
                )}
              </Flex>
            </Box>

            <Box flex={1}>
              <SelectInputForm
                name={userType?.name}
                label={userType?.label}
                options={optionsUserType}
                isDisabled={view}
                placeholder={userType?.placeholder}
                control={control}
                errors={errors}
              />
            </Box>
          </Flex>

          <Flex gap={5} flexWrap="wrap">
            <Box flex={1} minW={{ base: '100%', md: '300px' }}>
              <Flex direction="column" gap={2}>
                <SelectInputForm
                  name={modules?.name}
                  label={modules?.label}
                  options={formattedModuleOptions}
                  isLoading={loadingModules}
                  isDisabled={view}
                  pagination={paginationModules}
                  getOptions={(filters) => reqApiModules('get', { params: { ...filters } })}
                  placeholder={modules?.placeholder}
                  control={control}
                  errors={errors}
                  isMulti
                />
                {!view && (
                  <Flex direction="column" gap={1}>
                    <Button
                      size="sm"
                      w={{ base: '100%', sm: 'auto' }}
                      alignSelf={{ base: 'stretch', sm: 'flex-start' }}
                      variant={applyAllModules ? 'solid' : 'outline'}
                      onClick={handleToggleAllModules}
                      isLoading={isSelectingAllModules}
                      isDisabled={loadingModules || isSelectingAllModules}
                    >
                      {applyAllModules ? 'Remover seleção de todos' : 'Aplicar em todos os módulos'}
                    </Button>
                    {selectedModulesCount > 0 && (
                      <Text fontSize="xs" color="content.subtle">
                        {selectedModulesCount}{' '}
                        {selectedModulesCount > 1 ? 'módulos selecionados' : 'módulo selecionado'}
                        {applyAllModules ? ' (todos)' : ''}
                      </Text>
                    )}
                  </Flex>
                )}
              </Flex>
            </Box>

            <Box flex={1} minW={{ base: '100%', md: '300px' }}>
              <SelectInputForm
                name={category?.name}
                label={category?.label}
                options={[...(optionsCategories?.map((item) => getFormattedLabel(item)) ?? [])]}
                isLoading={loadingCategories}
                pagination={paginationCategories}
                getOptions={(filters) => reqApiCategories('get', { params: { ...filters } })}
                placeholder={category?.placeholder}
                isRequired
                isDisabled={view}
                control={control}
                errors={errors}
              />
            </Box>

            <Box flex={1} minW={{ base: '100%', md: '300px' }}>
              <SelectInputForm
                name={type?.name}
                label={type?.label}
                options={optionsType}
                isDisabled={!!defaultValues?.name || view}
                isRequired
                placeholder={type?.placeholder}
                control={control}
                errors={errors}
              />
            </Box>
          </Flex>

          {(watch('type')?.value === 'LINK' || watch('type') === 'LINK') && (
            <Box w="50%">
              <InputForm
                name={link?.name}
                label={link?.label}
                placeholder={link?.placeholder}
                register={register}
                isDisabled={view}
                errors={errors}
                isRequired
              />
            </Box>
          )}

          {(watch('type')?.value === 'MIDIA' || watch('type') === 'MIDIA') && (
            <Box>
              <FileInputForm
                defaultVal={defaultValues?.file?.original}
                name={file?.name}
                label={file?.label}
                register={register}
                watch={watch}
                errors={errors}
                isRequired
              />
            </Box>
          )}
        </FormSection>

        <FormActions cancelTo="/extraMaterials" isLoading={isSubmitting} />
      </Box>
    </FormShell>
  );
}
